import React from 'react'
import PropTypes from 'prop-types'
import {
  CancelButton,
  ErrorWrapper,
  FooterWrapper,
  HelpAndButtonWrapper,
  HelpCopy,
  NextButton,
} from './component.styles'
import ApiErrorMessage from 'components/ApiErrorMessage'

const ModalFooter = ({
  cancelButtonText,
  className,
  handleNextButtonClick,
  handleCancelButtonClick,
  hasApiError,
  helpCopy,
  isValid,
  isSubmitting,
  modalName = 'default',
  nextButtonText,
  showCancelButton = true,
}) => {
  return (
    <FooterWrapper className={className}>
      <HelpAndButtonWrapper>
        <HelpCopy>{helpCopy}</HelpCopy>
        <div>
          {showCancelButton && (
            <CancelButton
              data-testid={`${modalName}-modal-cancel-button`}
              disabled={isSubmitting}
              onClick={() => handleCancelButtonClick()}
            >
              {cancelButtonText}
            </CancelButton>
          )}
          <NextButton
            data-testid={`${modalName}-modal-next-button`}
            disabled={!isValid || isSubmitting}
            onClick={() => handleNextButtonClick()}
          >
            {nextButtonText}
          </NextButton>
        </div>
      </HelpAndButtonWrapper>
      {hasApiError && (
        <ErrorWrapper>
          <ApiErrorMessage />
        </ErrorWrapper>
      )}
    </FooterWrapper>
  )
}

ModalFooter.propTypes = {
  cancelButtonText: PropTypes.string,
  className: PropTypes.string,
  handleCancelButtonClick: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  hasApiError: PropTypes.bool,
  helpCopy: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  modalName: PropTypes.string,
  nextButtonText: PropTypes.string,
  showCancelButton: PropTypes.bool,
}

export default ModalFooter
